import { render, staticRenderFns } from "./Caretaker.vue?vue&type=template&id=4c1bf68d"
import script from "./Caretaker.vue?vue&type=script&lang=js"
export * from "./Caretaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports